import { fetch } from '../utils/fetch'

/**
 * 查询标签列表
 * @returns {Promise<Response>}
 */
export function _queryGoodsTags(
  {
    name,
    page,
    size,
    direction,
    sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-tag`,
    method: 'get',
    params: {
      name,
      page,
      size,
      direction,
      sort,
    },
  })
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsTag(goodsTagId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-tag/${goodsTagId}`,
    method: 'get',
  })
}

/**
 * 新增
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _addGoodsTag(
  {
    name,
    price,
    country,
    paramKey,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-tag`,
    method: 'post',
    data: {
      name,
      price,
      country,
      paramKey,
    },
  })
}

/**
 * 更新
 * @param  name
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _updateGoodsTag(goodsTagId,
  {
    name,
    price,
    country,
    paramKey,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-tag/${goodsTagId}`,
    method: 'patch',
    data: {
      name,
      price,
      country,
      paramKey,
    },
  })
}

/**
 * 删除
 * @param GoodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoodsTag(goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/website-goods-tag/${goodsId}`,
    method: 'delete',
  })
}

export default {}
